import axiosInstance from '../../utils/axios';

/**
 * Check if an affiliation link should redirect to the main website.
 * @param affiliateId UUID of the affiliate.
 * @returns boolean
 */
export const shouldRedirectToWebsite = async (
  affiliateId: string
): Promise<boolean> => {
  try {
    const response = await axiosInstance.get<boolean>(
      `/affiliations/${affiliateId}/redirect`
    );
    return response.data === true;
  } catch (error) {
    console.error('Error fetching redirectOnWebsite:', error);
    return false;
  }
};

/**
 * Toggle the redirectOnWebsite flag for a given affiliation.
 * @param affiliateId UUID of the affiliate.
 * @returns boolean (new state after toggle)
 */
export const toggleRedirectOnWebsite = async (
  affiliateId: string
): Promise<boolean> => {
  try {
    const response = await axiosInstance.patch<boolean>(
      `/affiliations/${affiliateId}/redirect`
    );
    return response.data;
  } catch (error) {
    console.error('Error toggling redirectOnWebsite:', error);
    throw error;
  }
};
